import { render, staticRenderFns } from "./StandardLayout.vue?vue&type=template&id=279ea136&"
import script from "./StandardLayout.vue?vue&type=script&lang=js&"
export * from "./StandardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports